import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  const phone = "917975399846";
  const msg = encodeURIComponent("Hi Dreamy Interiors, I'd like to know more about your services.");
  return (
    <a
      data-testid="whatsapp-fab"
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 left-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform"
      aria-label="WhatsApp us"
    >
      <MessageCircle size={26} />
    </a>
  );
}
